import { Box, Container, Heading } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { Link } from 'gatsby';
import ArrowButton from '../../ui/ArrowButton';

const ProtectSection = () => (
  <Box bg="brandGreen.100" py="73px" mt={1000} position="relative" w="100%">
    <Container
      maxW="6xl"
      overflow="hidden"
      display="flex"
      flexDir="column"
      justifyContent="center"
      alignItems="center"
    >
      <Box
        style={{
          position: 'absolute',
          margin: 'auto',
          left: 0,
          right: 0,
          top: '-53px',
          textAlign: 'center',
        }}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <StaticImage
          quality={100}
          placeholder="blurred"
          src="../../../assets/images/protect_vector.png"
          alt="protect vector"
        />
      </Box>
      <Heading
        size={{ base: 600, tablet: 700, desktop: 800 }}
        color="brandGreen.500"
        fontWeight={{ base: 600, desktop: 700 }}
        marginBottom={{ base: 400, desktop: 400 }}
      >
        Privacy First
      </Heading>
      <Heading
        size={{ base: 400, desktop: 500 }}
        marginBottom={{ base: 0, desktop: 0 }}
        isDisplay
        maxW="3xl"
        textAlign="center"
        pb={700}
      >
        We’ll never sell your data. You own your home’s address, measurements,
        estimates, and design plans.
      </Heading>
      <ArrowButton
        colorScheme="primary"
        variant="outline"
        mb={400}
        as={Link}
        to={`${process.env.GATSBY_V2_PREFIX}/privacy`}
        w={{ base: '100%', tablet: 'auto' }}
      >
        See our Privacy Policy
      </ArrowButton>
    </Container>
  </Box>
);

export default ProtectSection;
